import CryptoJS from "crypto-js";

export const getApikey = () => {
  const authPass = process.env.REACT_APP_API_KEY;

  const date = new Date();
  const actDate = `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;

  const toTimestamp = (strDate) => {
    const dt = Date.parse(strDate);
    return dt / 1000;
  };

  const sha512 = (str) => {
    return CryptoJS.enc.Hex.stringify(CryptoJS.SHA512(str));
  };
  const timeMark = toTimestamp(actDate);
  const value = sha512(`${timeMark}:${authPass}`);
  return `authFinal${value}.lVzbgLw6zSaRvItqnZcBt6Bt8_VVZa_T`;
};
